import React from 'react';

export const discordAvatarUrl = (user, size = 96) => {
  if (!user?.id) return null;
  if (user.avatar) {
    return `https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}.png?size=${size}`;
  }
  const index = Number(String(user.id).slice(-2)) % 6;
  return `https://cdn.discordapp.com/embed/avatars/${index}.png`;
};

/** Chip com avatar + nome (fallback para ID se o perfil não resolver). */
export default function DiscordUserChip({
  user,
  userId,
  fallbackTag,
  compact = false,
}) {
  const id = user?.id || userId;
  if (!id && !fallbackTag && !user?.displayName) {
    return <span>—</span>;
  }

  const name =
    user?.displayName ||
    user?.globalName ||
    user?.username ||
    fallbackTag ||
    null;
  const src =
    user?.avatarUrl ||
    (user ? discordAvatarUrl(user, compact ? 40 : 64) : null) ||
    (id
      ? `https://cdn.discordapp.com/embed/avatars/${Number(String(id).slice(-2)) % 6}.png`
      : null);

  if (!name && id) {
    return <span className="admin-mono">{id}</span>;
  }

  return (
    <span
      className={`admin-user-chip${compact ? ' admin-user-chip--compact' : ''}`}
    >
      {src && (
        <img
          src={src}
          alt=""
          className="admin-user-chip__avatar"
          width={compact ? 20 : 28}
          height={compact ? 20 : 28}
          loading="lazy"
          referrerPolicy="no-referrer"
        />
      )}
      <span className="admin-user-chip__name" title={id || undefined}>
        {name}
      </span>
    </span>
  );
}
